export type VodShow = {
  img: string
  titleFA: string
  titleEN: string
  genreFA: string
  genreEN: string
}

export type VodPlatform = {
  id: string
  name: string
  nameFA: string
  tagEN: string
  tagFA: string
  color: string
  colorLight: string
  border: string
  heroBg: string
  heroImg: string
  descEN: string
  descFA: string
  formatsEN: string[]
  formatsFA: string[]
  perksEN: string[]
  perksFA: string[]
  shows: VodShow[]
}

export type AudienceBar = {
  ageEN: string
  ageFA: string
  val: number
}

export const vodPlatforms: VodPlatform[] = [
  {
    id: 'filmnet',
    name: 'Filmnet',
    nameFA: 'فیلم‌نت',
    tagEN: "One of Iran's leading VOD platforms.",
    tagFA: 'یکی از پلتفرم‌های اصلی VOD ایران',
    color: '#0a2d8f',
    colorLight: 'rgba(10,45,143,0.08)',
    border: 'rgba(10,45,143,0.18)',
    heroBg: 'linear-gradient(145deg, #0d3da5 0%, #071d60 55%, #020c30 100%)',
    heroImg: 'photos/vod/filmnet-cover.png',
    descEN:
      "One of Iran's major VOD players; home to high-traffic content and an engaged audience.",
    descFA: 'یکی از بازیگران اصلی VOD ایران؛ خانه محتوای پربیننده و مخاطبان پیگیر.',
    formatsEN: [
      'Pre-roll (Day Series)',
      'Mid-roll (Day Series)',
      'Pre-roll (Reality Show)',
      'Mid-roll (Reality Show)',
      'Archival Pre-roll',
      'Archival Mid-roll',
    ],
    formatsFA: [
      'پری‌رول (سریال روز)',
      'میدرول (سریال روز)',
      'پری‌رول (رئالیتی شو)',
      'میدرول (رئالیتی شو)',
      'پری‌رول آرشیوی',
      'میدرول آرشیوی',
    ],
    perksEN: [
      '10M+ daily archival views, ad stays live forever',
      'Paid subscribers: highest content attention in Iran',
      'Pre-roll in top-rated dramas, unskippable first seconds',
      'Brand-safe inventory: 100% licensed, curated content',
      'UTM tracking + real-time view dashboard',
      'Archival CPV model: pay only per completed view',
    ],
    perksFA: [
      '۱۰+ میلیون بازدید آرشیوی روزانه، تبلیغ برای همیشه زنده می‌ماند',
      'اشتراک‌پذیران پولی: بالاترین توجه به محتوا در ایران',
      'پری‌رول در سریال‌های پربیننده، ثانیه‌های اول غیرقابل رد',
      'موجودی برند-سیف: ۱۰۰٪ محتوای مجوزدار و منتخب',
      'ردیابی UTM + داشبورد لحظه‌ای بازدید',
    ],
    shows: [
      {
        img: 'photos/vod/filmnet-biateefeh.jpeg',
        titleFA: 'بی‌عاطفه',
        titleEN: 'Bi-Atefe',
        genreFA: 'درام اجتماعی',
        genreEN: 'Drama',
      },
      {
        img: 'photos/vod/filmnet-21.jpeg',
        titleFA: 'بیست‌ویک',
        titleEN: 'Bis-o-yek',
        genreFA: 'پلیسی',
        genreEN: 'Thriller',
      },
      {
        img: 'photos/vod/filmnet-standup.jpeg',
        titleFA: 'استند‌آپ کمدی',
        titleEN: 'Stand-up',
        genreFA: 'کمدی',
        genreEN: 'Comedy',
      },
      {
        img: 'photos/vod/filmnet-shahgol.jpeg',
        titleFA: 'شاهگل',
        titleEN: 'Shahgol',
        genreFA: 'رئالیتی‌شو',
        genreEN: 'Reality',
      },
    ],
  },
  {
    id: 'shida',
    name: 'Sheida',
    nameFA: 'شیدا',
    tagEN: 'A platform with diverse content and a modern online streaming experience.',
    tagFA: 'پلتفرمی با محتوای متنوع و تجربه‌ای مدرن از نمایش آنلاین.',
    color: '#7C3AED',
    colorLight: 'rgba(124,58,237,0.08)',
    border: 'rgba(124,58,237,0.18)',
    heroBg: 'linear-gradient(145deg, #8B46F0 0%, #5B21B6 55%, #1E0A50 100%)',
    heroImg: 'photos/vod/shida-cover.png',
    descEN:
      'A next-generation VOD platform; host to movies, series, and entertainment programs, with a focus on a modern viewing experience and popular content.',
    descFA:
      'پلتفرم VOD نسل جدید؛ میزبان فیلم، سریال و برنامه‌های سرگرمی با تمرکز بر تجربه تماشای مدرن و محتوای پرمخاطب.',
    formatsEN: ['Pre-roll A+', 'Pre-roll A', 'Mid-roll A', 'Mid-roll A+'],
    formatsFA: ['پری‌رول A+', 'پری‌رول A', 'میدرول A', 'میدرول A+'],
    perksEN: [
      '58.8% male / 41.2% female, balanced premium audience',
      "18–34 dominant: Iran's highest-purchasing age group",
      'A+ inventory: full-screen, unskippable first impression',
      'Multi-genre targeting: drama, reality, horror, talk shows',
      'Provincial + national reach in a single campaign',
      'Complete attribution: views, clicks, completion rate',
    ],
    perksFA: [
      '۵۸.۸٪ مرد / ۴۱.۲٪ زن، مخاطب پریمیوم متعادل',
      'غالب ۱۸–۳۴ ساله: بالاترین قدرت خرید ایران',
      'موجودی A+: تمام صفحه، اولین ایمپرشن غیرقابل رد',
      'هدف‌گیری چند ژانره: درام، رئالیتی، ترسناک، تاک‌شو',
      'پوشش استانی + سراسری در یک کمپین واحد',
      'اتریبیوشن کامل: بازدید، کلیک، نرخ تکمیل',
    ],
    shows: [
      {
        img: 'photos/vod/shida-mobemo.jpeg',
        titleFA: 'مو‌به‌مو',
        titleEN: 'Mo Be Mo',
        genreFA: 'رازآلود',
        genreEN: 'Mystery',
      },
      {
        img: 'photos/vod/shida-reality-cast.jpeg',
        titleFA: 'کاست',
        titleEN: 'Kasset',
        genreFA: 'موسیقی',
        genreEN: 'Music Reality',
      },
      {
        img: 'photos/vod/shida-shabhol.jpeg',
        titleFA: 'شب‌هول',
        titleEN: 'Shab-houl',
        genreFA: 'ترسناک',
        genreEN: 'Horror',
      },
      {
        img: 'photos/vod/shida-iranshahr.jpeg',
        titleFA: 'ایرانشهر',
        titleEN: 'Iranshahr',
        genreFA: 'تاک‌شو',
        genreEN: 'Talk Show',
      },
    ],
  },
]

export const audienceBars: AudienceBar[] = [
  { ageEN: '18–24', ageFA: '۱۸–۲۴', val: 231066 },
  { ageEN: '25–34', ageFA: '۲۵–۳۴', val: 182837 },
  { ageEN: '35–44', ageFA: '۳۵–۴۴', val: 97724 },
  { ageEN: '45–54', ageFA: '۴۵–۵۴', val: 28434 },
  { ageEN: '55–64', ageFA: '۵۵–۶۴', val: 16067 },
  { ageEN: '65+', ageFA: '۶۵+', val: 19592 },
]

export const MAX_AUDIENCE_BAR = 231066
